import React, { useState, useRef, useEffect } from "react";
import { disabledIfFieldChecker } from "../../utils/helperFuctions";

function ClickableImage({
  imageClicked,
  name,
  clicks,
  parentParamName,
  parentId,
  adddata,
  exclude,
  disabledIfField,
  currentFields,
  disabled,
}) {
  const initClicks = () => {
    if (Array.isArray(clicks)) {
      return clicks.filter((x) => x.delete !== true);
    }
    return [];
  };
  const [_clicks, setClicks] = useState(initClicks());
  const [imageDimensions, setImageDimensions] = useState({
    width: 0,
    height: 0,
  });
  const imageRef = useRef(null);
  useEffect(() => {
    setClicks(initClicks());
  }, [clicks]);
  const handleImageLoad = () => {
    if (imageRef.current) {
      const { naturalWidth, naturalHeight } = imageRef.current;
      setImageDimensions({ width: naturalWidth, height: naturalHeight });
    }
  };

  const handleImageClick = (event) => {
    if (imageRef.current) {
      const imageRect = imageRef.current.getBoundingClientRect();
      const xPercentage =
        ((event.clientX - imageRect.left) / imageRect.width) * 100;
      const yPercentage =
        ((event.clientY - imageRect.top) / imageRect.height) * 100;

      if (_clicks && Array.isArray(_clicks) && _clicks.length > 0) {
        // Find the maximum 'number' in the array
        const maxNumber = Math.max(..._clicks.map((item) => item.number));
        // Add a new object with number as maxNumber + 1

        if (imageClicked instanceof Function) {
          imageClicked(
            {
              ...{
                xp: xPercentage,
                yp: yPercentage,
                number: maxNumber + 1,
                date_created: new Date().toISOString(),
                user_created: { first_name: "You", last_name: "" },
                [parentParamName]: parentId,
              },
              ...adddata,
            },
            name
          );
        }
      } else {
        // If the array is empty, start with number 1

        if (imageClicked instanceof Function) {
          imageClicked(
            {
              ...{
                xp: xPercentage,
                yp: yPercentage,
                number: 1,
                date_created: new Date().toISOString(),
                user_created: { first_name: "You", last_name: "" },
                [parentParamName]: parentId,
              },
              ...adddata,
            },
            name
          );
        }
      }

      //set_clicks(_temp_clicks);
    }
  };
  const isFieldDisabled =
    disabledIfField != null
      ? disabled ||
        disabledIfFieldChecker(currentFields, {
          field: disabledIfField.field,
          valuesArray: disabledIfField.isEqual,
        })
      : disabled ?? false;

  return (
    <div className="relative">
      <img
        src="/vehicleDamages.png" // Replace with your image source
        alt="Clickable Image"
        onLoad={handleImageLoad}
        onClick={(e) => {
          if (isFieldDisabled === true) return;
          handleImageClick(e);
        }}
        style={{
          cursor: isFieldDisabled === true ? "not-allowed" : "crosshair",
        }}
        ref={imageRef}
        className="relative "
      />

      {_clicks &&
        Array.isArray(_clicks) &&
        (exclude
          ? _clicks.filter((x) => x[exclude.name] !== exclude.value)
          : _clicks
        ).map((click, index) => (
          <div
            key={index}
            className="click-number absolute"
            style={{
              left: `${click.xp}%`,
              top: `${click.yp}%`,
              color: "red",
              fontWeight: "bold",
              fontSize: "16px",
              position: "absolute",
              transform: "translate(-50%, -50%)", // Center align the number
              WebkitTextStroke: "1px black", // Dark stroke around the number
            }}
          >
            {click.number}
          </div>
        ))}
    </div>
  );
}

export default ClickableImage;
